
import { CourseSchedule } from '@/types';

// Helper function to map database schedule to frontend model
export const mapScheduleToModel = (
  schedule: any,
  startDate: Date,
  endDate: Date
): CourseSchedule => ({
  id: schedule.schedule_id?.toString() || '',
  courseId: schedule.course_id?.toString() || '',
  startDate: schedule.start_date || '',
  endDate: endDate.toISOString().split('T')[0],
  location: schedule.location || '',
  availableSeats: schedule.capacity || 0,
  bookedSeats: 0,
  // Override price to 0 when buy_or_apply is 'A'
  price: schedule.buy_or_apply === 'A' ? 0 : (schedule.course?.price || 0),
  status: schedule.status === "ongoing" ? "ongoing" 
    : schedule.status === "completed" ? "completed"
    : schedule.status === "cancelled" ? "cancelled"
    : "upcoming",
  createdAt: schedule.created_at || new Date().toISOString(),
  updatedAt: schedule.created_at || new Date().toISOString(),
  buy_or_apply: schedule.buy_or_apply || 'B',
  course: {
    id: schedule.course?.course_id?.toString() || '',
    title: schedule.course?.code || '',
    slug: (schedule.course?.code || '').toLowerCase().replace(/\s+/g, '-'),
    category: schedule.course?.category || schedule.course?.tech || '',
  }
});

